export function generatePathForCategoryIdPath(
  basePath: string,
  idPath: string[]
): string {
  return `${basePath}/${idPath.join('/')}`
}
